import {createSelector} from 'reselect';
import {AppState} from '../..';

export const latestNewsSelector = () =>
  createSelector(
    (state: AppState) => state.news?.latest,
    (item) => item,
  );

export const newsByIdSelector = createSelector(
  (state: AppState) => state.news?.byId,
  (item) => item,
);
